import httpClient from './index';

const END_POINT = 'login';

const login = (data) => httpClient.post(`${END_POINT}`, {...data});

export { login };